/**
 * Diary Quiz Set 선택 드롭다운
 * ComponentOptionsEditor에서 assignment 타입일 때 사용
 */
import { useTranslation } from 'react-i18next'
import { useQuery } from '@tanstack/react-query'
import { Loader2 } from 'lucide-react'
import { getDiaryQuizSets } from '@/api/diaryQuizSet'

interface DiaryQuizSetSelectorProps {
  value?: number
  onChange: (setId: number | undefined) => void
}

export const DiaryQuizSetSelector: React.FC<DiaryQuizSetSelectorProps> = ({
  value,
  onChange
}) => {
  const { t } = useTranslation('configuration')
  const { data: sets, isLoading } = useQuery({
    queryKey: ['diary-quiz-sets'],
    queryFn: getDiaryQuizSets
  })

  if (isLoading) {
    return (
      <div className="flex items-center gap-2 text-sm text-slate-400">
        <Loader2 className="w-4 h-4 animate-spin" />
        {t('diaryQuiz.loading')}
      </div>
    )
  }

  return (
    <div>
      <label className="block text-sm text-gray-700 mb-1">{t('diaryQuiz.label')}</label>
      <select
        value={value ?? ''}
        onChange={(e) => {
          const v = e.target.value
          onChange(v ? parseInt(v) : undefined)
        }}
        className="w-full px-3 py-1.5 border border-gray-300 rounded-md text-sm focus:ring-blue-500 focus:border-blue-500"
      >
        <option value="">{t('diaryQuiz.noSelection')}</option>
        {sets?.map((set) => (
          <option key={set.id} value={set.id}>
            {set.name} ({t('diaryQuiz.itemCount', { count: set.itemCount })})
          </option>
        ))}
      </select>
      <span className="text-xs text-gray-500">
        {t('diaryQuiz.description')}
      </span>
    </div>
  )
}
